(function () {
  // ===== 설정 =====
  var CONFIG = {
    API_KEY:  '66920803-c1e5-4ee5-8d85-28ceda5d7d2b',
    USER_KEY: 'service1',
    DEBUG:    false,

    // 사이즈는 일단 보류
    WIDTH:  null,   // 예: 400
    HEIGHT: null,   // 예: 620

    // 헤더 주입 도메인
    KEY_DOMAINS: ['https://developers.tbmini.im'],

    // 가시성 세이프가드(필요할 때만 true)
    SAFE_VISIBILITY: false
  };

  function log(){ if (CONFIG.DEBUG) console.log('[TBMINI]', ...arguments); }
  function warn(){ if (CONFIG.DEBUG) console.warn('[TBMINI]', ...arguments); }
  function err(){ console.error('[TBMINI]', ...arguments); }


  // ---------- 유틸 ----------
  function getSDK(){
    var s = window.TaggingSDK || window.TBMINI || window.Tbmini || null;
    return (s && s.default) ? s.default : s;
  }

  function ensureContainer(){
    var c = document.getElementById('tagging-container');
    if (!c) {
      c = document.createElement('div');
      c.id = 'tagging-container';
      document.body.appendChild(c);
    }
    Object.assign(c.style, {
      position: 'fixed',
      top: '11rem',
      right: '5rem',
      zIndex: '2147483647'
    });
    return c;
  }

  function ensureSdkLoaded(cb){
    if (getSDK()) return cb();

    if (document.getElementById('tbmini-sdk')) {
      document.addEventListener('tbmini:sdk-ready', cb, { once: true });
      return;
    }
    var s = document.createElement('script');
    s.id = 'tbmini-sdk';
    s.src = 'https://unpkg.com/tbmini-sdk/dist/tbmini-sdk.min.js';
    s.async = true;
    s.onload = function(){
      document.dispatchEvent(new Event('tbmini:sdk-ready'));
      cb();
    };
    s.onerror = function(){ err('failed to load tbmini sdk'); };
    document.head.appendChild(s);
  }

  // ---------- fetch 안전 오버라이드 ----------
  (function forceAppKeyHeader(){
    var ORIG_FETCH = window.fetch;
    function needsKey(url){ return CONFIG.KEY_DOMAINS.some(function(p){ return url && url.indexOf(p) === 0; }); }
    window.fetch = function(input, init){
      try {
        var req = (typeof input === 'string') ? new Request(input, init) : input;
        var url = req && req.url ? req.url : '';
        var method = (req && req.method ? req.method : 'GET').toUpperCase();
        if (!needsKey(url) || method === 'OPTIONS') {
          return (typeof input === 'string') ? ORIG_FETCH(input, init) : ORIG_FETCH(req);
        }
        var headers = new Headers(req.headers);
        headers.set('x-api-key', CONFIG.API_KEY);
        var cloned = new Request(req, { headers: headers });
        return ORIG_FETCH(cloned);
      } catch (e) {
        return ORIG_FETCH(input, init);
      }
    };
  })();

  // ---------- 초기화 ----------
  function initAndMount(){
    if (window.__tbmini_inited) return;
    var container = ensureContainer();

    var SDK = getSDK();
    if (!SDK) return err('TaggingSDK not found');

    var ok = false;
    try {
      // A) 최상위 API
      if (!ok && typeof SDK.init === 'function' && typeof SDK.createTaggingBox === 'function') {
        SDK.init({ applicationKey: CONFIG.API_KEY, userKey: CONFIG.USER_KEY });
        var optA = { containerId: 'tagging-container' };
        if (typeof CONFIG.WIDTH  === 'number') optA.width  = CONFIG.WIDTH;
        if (typeof CONFIG.HEIGHT === 'number') optA.height = CONFIG.HEIGHT;
        SDK.createTaggingBox(optA);
        ok = true;
      }

      // B) 네임스페이스 API
      if (!ok && SDK.TaggingBox && typeof SDK.TaggingBox.init === 'function') {
        var optB = { containerId: 'tagging-container', applicationKey: CONFIG.API_KEY, userKey: CONFIG.USER_KEY };
        if (typeof CONFIG.WIDTH  === 'number') optB.width  = CONFIG.WIDTH;
        if (typeof CONFIG.HEIGHT === 'number') optB.height = CONFIG.HEIGHT;
        SDK.TaggingBox.init(optB);
        ok = true;
      }

      // C) apis.* 스타일
      if (!ok) {
        var apis = SDK.apis || {};
        var box  = apis.TaggingBox || apis.taggingBox || apis.box || apis.widget || null;

        if (SDK.config && typeof SDK.config.set === 'function') {
          SDK.config.set({ applicationKey: CONFIG.API_KEY, userKey: CONFIG.USER_KEY });
        }

        if (typeof apis.initTaggingBox === 'function') {
          var optC = { containerId: 'tagging-container', applicationKey: CONFIG.API_KEY, userKey: CONFIG.USER_KEY };
          if (typeof CONFIG.WIDTH  === 'number') optC.width  = CONFIG.WIDTH;
          if (typeof CONFIG.HEIGHT === 'number') optC.height = CONFIG.HEIGHT;
          apis.initTaggingBox(optC);
          ok = true;
        } else if (box && typeof box.init === 'function') {
          var optD = { containerId: 'tagging-container', applicationKey: CONFIG.API_KEY, userKey: CONFIG.USER_KEY };
          if (typeof CONFIG.WIDTH  === 'number') optD.width  = CONFIG.WIDTH;
          if (typeof CONFIG.HEIGHT === 'number') optD.height = CONFIG.HEIGHT;
          box.init(optD);
          ok = true;
        }
      }
    } catch (e) { warn('init error:', e); }

    if (ok) {
      window.__tbmini_inited = true;
      log('Initialized.');
    } else {
      warn('Unknown SDK API shape.');
    }

    // 수동 open(쿨다운)
    window._tbOpen = (function(){
      var last = 0, inFlight = false;
      return function(){
        var now = Date.now();
        if (now - last < 2000 || inFlight) return;
        last = now; inFlight = true;
        try {
          var SDK = getSDK(), apis = SDK && SDK.apis || {};
          var box = apis && (apis.TaggingBox || apis.taggingBox || apis.box || apis.widget);
          if (!box) return;
          if (typeof box.open  === 'function') box.open();
          else if (typeof box.show  === 'function') box.show();
          else if (typeof box.mount === 'function') box.mount({ containerId: 'tagging-container' });
          log('manual open attempted');
        } catch(e){ err(e); }
        finally { setTimeout(function(){ inFlight=false; }, 300); }
      };
    })();

    // (옵션) 가시성 세이프가드
    if (CONFIG.SAFE_VISIBILITY) {
      var keepVisible = function(){
        var el = document.querySelector('.tagging-sdk-container, .tagging-sdk-root');
        if (!el) return;
        var cs = getComputedStyle(el);
        if (cs && cs.display === 'none') {
          el.style.setProperty('display','block','important');
          el.style.setProperty('opacity','1','important');
          el.style.setProperty('visibility','visible','important');
          el.style.setProperty('pointer-events','auto','important');
        }
      };
      new MutationObserver(function(){ keepVisible(); })
        .observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['style','class','aria-hidden'] });
      keepVisible();
      window._tbShow = keepVisible;
    }
  }

  // ---------- 엔트리 ----------
  function start(){
    ensureSdkLoaded(function(){
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAndMount, { once: true });
      } else {
        initAndMount();
      }
    });
  }

  // 최초 진입
  start();

  // Shopify 섹션 리로드 시 중복 방지
  document.addEventListener('shopify:section:load', function(){
    if (!window.__tbmini_inited) start();
  });

  // 플로팅 버튼 아이콘이 동적으로 생겨도 보이게만
  (new MutationObserver(function () {
    var el = document.querySelector('.tagging-sdk-icon-container');
    if (el) el.style.display = 'block';
  })).observe(document.body, { childList:true, subtree:true });

})();
// [TBMINI] Visibility Guardian — 컨테이너 하위가 display:none 되면 즉시 복구
(function tbminiVisibilityGuardian(){
  var ROOT_ID = 'tagging-container';
  var DEBUG = false; // 필요하면 true로

  function getRoot(){ return document.getElementById(ROOT_ID); }

  // 숨김으로 내려가는 "화면 후보" 판단 (클래스 몰라도 범용)
  function isViewCandidate(el){
    if (!(el instanceof Element)) return false;
    if (/^(SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/i.test(el.tagName)) return false;
    var cls = (el.className || '') + '';
    var role = el.getAttribute && el.getAttribute('role');
    return (
      /\b(container|panel|root|view|content|sdk|list|body)\b/i.test(cls) ||
      role === 'tabpanel' || role === 'dialog' || role === 'region'
    );
  }

  // 보이기 강제
  function ensureVisible(el){
    var cs = getComputedStyle(el);
    if (!cs) return;
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0' || (el.offsetWidth+el.offsetHeight) === 0){
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('pointer-events', 'auto', 'important');
      el.style.setProperty('transform', 'none', 'important');

      // 상위가 잘라먹는 케이스 방지
      var p = el.parentElement, guard = 0;
      while (p && guard++ < 4){
        var pcs = getComputedStyle(p);
        if (pcs.overflow === 'hidden') p.style.setProperty('overflow', 'visible', 'important');
        if (pcs.visibility === 'hidden') p.style.setProperty('visibility', 'visible', 'important');
        p = p.parentElement;
      }
      if (DEBUG) console.log('[TBMINI][Vis] restored', el.className || el);
    }
  }

  // 루트 전체 훑기
  function sweep(){
    var root = getRoot(); if (!root) return;
    // display:none 요소는 querySelector로 바로 못 잡을 수 있으니 전체 순회
    var nodes = root.querySelectorAll('*');
    nodes.forEach(function(n){ if (isViewCandidate(n)) ensureVisible(n); });
  }

  // 초기 한 번 + 살짝 늦춰서 한 번 더
  sweep(); setTimeout(sweep, 50);

  // 변화 감시(디바운스)
  var t = null;
  var mo = new MutationObserver(function(muts){
    // 루트 내부 변화만 반응
    var root = getRoot(); if (!root) return;
    var touched = false;
    for (var i=0;i<muts.length;i++){
      var m = muts[i];
      if (m.type === 'childList') touched = true;
      else if (m.type === 'attributes') {
        if (m.attributeName === 'style' || m.attributeName === 'class' || m.attributeName === 'aria-hidden') touched = true;
      }
      if (touched) break;
    }
    if (!touched) return;
    clearTimeout(t); t = setTimeout(sweep, 40);
  });
  mo.observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['style','class','aria-hidden'] });

  // 수동 호출/토글
  window.tbVis = {
    nudge: sweep,
    on: function(){ mo.disconnect(); mo.observe(document.body, { childList:true, subtree:true, attributes:true, attributeFilter:['style','class','aria-hidden'] }); },
    off: function(){ mo.disconnect(); },
    debug: function(v){ DEBUG = !!v; }
  };

  // CSS 한 방(선택): 컨테이너 직계/주요 뷰 100% 보이기
  (function injectBaseCss(){
    var css = `
#${ROOT_ID} > * { display:block !important; visibility:visible !important; opacity:1 !important; }
#${ROOT_ID} .tagging-sdk-root, 
#${ROOT_ID} .tagging-sdk-container, 
#${ROOT_ID} .tagging-sdk-panel, 
#${ROOT_ID} [role="tabpanel"] { display:block !important; visibility:visible !important; opacity:1 !important; }
`;
    var s = document.getElementById('tbmini-vis-css') || document.createElement('style');
    s.id = 'tbmini-vis-css'; s.textContent = css; document.head.appendChild(s);
  })();
})();
